import(/* webpackMode: "eager" */ "D:\\AppYogi software\\2nd Number App\\second-number\\src\\app\\page.js");
